export default({
	data: function () {
        return {
            text: []
		};
	},

    mounted: function () {
        this.loadChangelog();
    },

	methods: {
        loadChangelog: function () {
                this.$http.get('/data/changelog-moderated.txt').then(response => {
                    this.text = response.bodyText.replace(/\n/g, '<br />').replace(/ \*/g, '&nbsp;&middot;&nbsp;');

            }, error => {
                this.error = 'Something went wrong with our server. Please contact System Administrator (code ' + error.status + ')';
                this.auth_on = false;
            });
		}
	}
});




// WEBPACK FOOTER //
// ./src/components/external/changelog/changelog.js